module.exports = __webpack_public_path__ + "img/state-of-survival.4e1fde7.jpg";